import { render, staticRenderFns } from "./ReporteIncidenciasMensual.vue?vue&type=template&id=229d47b0&"
import script from "./ReporteIncidenciasMensual.vue?vue&type=script&lang=js&"
export * from "./ReporteIncidenciasMensual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports